import React from 'react';
import './styles.css';

const ScrollDownIcon = () => {
  return (
    <span className='scroll'>
      <span className="scrollDown">
        <span></span>
      </span>
    </span>
  )
};

export default ScrollDownIcon;
